import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { amendDcr, amendDer } from '../api/billing.api';
import type { AmendDcrPayload, AmendDerPayload } from '../types/billing.types';

const FAILURE = 'Could not change this claim';

export function useAmendDcr() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ recordId, payload }: { recordId: number; payload: AmendDcrPayload }) =>
      amendDcr(recordId, payload),
    onSuccess: () => {
      void refreshRelatedData('billingEntry');
      toast.success('Claim corrected');
    },
    onError: (error) => showApiErrorToast(error, FAILURE),
  });
}

export function useAmendDer() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ detailId, payload }: { detailId: number; payload: AmendDerPayload }) =>
      amendDer(detailId, payload),
    onSuccess: () => {
      void refreshRelatedData('billingEntry');
      toast.success('Claim corrected');
    },
    onError: (error) => showApiErrorToast(error, FAILURE),
  });
}
